/**
 * This file was auto-generated by Fern from our API Definition.
 */

import * as Truvity from '../index';

/**
 * A schema for Credential claim values that can contain multiple values.
 */
export type CredentialClaimValues = Record<string, Truvity.CredentialClaimValue>;
